<div class="outer">
  <div class="inner" *ngIf="!errorMessage">
    <p>処理中です。</p>
    <p>しばらくお待ち下さい。</p>
  </div>
  <div class="inner" *ngIf="errorMessage">
    <p>{{errorMessage}}</p>
  </div>
</div>